import { render, staticRenderFns } from "./balanceBySalesGroup.vue?vue&type=template&id=7b4ceb63&scoped=true"
import script from "./balanceBySalesGroup.vue?vue&type=script&lang=js"
export * from "./balanceBySalesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ceb63",
  null
  
)

export default component.exports